import React from 'react';
import {BaseFlag} from './BaseFlag';
import {FlagProps} from './types';

const Flag: React.FC<FlagProps> = ({countryCode}) => {
  const flagUri = `https://www.countryflags.io/${countryCode.toLowerCase()}/flat/64.png`;
  // const flagUri = '../../assets/flags/64px/${countryCode.toLowerCase()}64.png';
  const width = 22;

  return <BaseFlag uri={flagUri} width={width} />;
};

export {Flag};
